import type { CaptureResult } from "posthog-js";

const EVENTS = new Set([
  "pdf_edit_committed", "pdf_import_outcome",
  "pdf_entry_viewed", "pdf_document_added", "pdf_export_generated",
  "pdf_export_requested", "pdf_export_outcome", "pdf_export_feedback",
  "pdf_export_feedback_shown", "pdf_document_load_outcome",
]);
const PROPERTIES = new Set([
  "distinct_id", "$session_id", "$window_id", "$lib", "$lib_version",
  "$insert_id", "$process_person_profile", "$is_identified", "token",
  "import_id", "edit_category", "actor",
  "flow", "entry", "attempt_id", "export_id", "source", "input_format",
  "format", "committed_edit_observed", "schema_version", "release",
  "outcome", "reason", "stage", "duration_ms", "export_index", "retry_after_failure", "feedback_step",
]);

/** PDF measurements never inherit URLs, attribution strings or profile data. */
export function sanitizePdfMeasurement(event: CaptureResult | null): CaptureResult | null {
  if (!event || !EVENTS.has(event.event)) return event;
  const safe = { ...event };
  delete safe.$set;
  delete safe.$set_once;
  return { ...safe, properties: Object.fromEntries(
    Object.entries(event.properties || {}).filter(([key]) => PROPERTIES.has(key)),
  ) };
}
